import { render, staticRenderFns } from "./ListContentBlock.vue?vue&type=template&id=4913c16b"
import script from "./ListContentBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ListContentBlock.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports